import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, IconNames, Icon, Heading, Text } from '@dotcom/crown-ui';
import paymentImage from '../../../assets/PaymentConfirmation.svg';
import { Layout } from '../../../components/layout';
import { useAnalyticsContext } from '../../../context/analytics-context';
import styles from '../preview.module.scss';

type EmailSplashProps = {
  onPlayAnimations: () => void;
  onContinue: () => void;
};

export const EmailSplash = ({ onContinue, onPlayAnimations }: EmailSplashProps) => {
  const { trackViewEmailSplash, trackKeepShopping, isOnEmailSplashScreen } = useAnalyticsContext();
  const { t } = useTranslation();

  const keepShoppingOnClick = () => {
    trackKeepShopping();
    onContinue();
  };

  const viewDigitalGreetingOnClick = () => {
    trackViewEmailSplash();
    onPlayAnimations();
  };

  useEffect(() => {
    // keep track of splash screen for analytics events
    isOnEmailSplashScreen.current = true;

    return () => {
      isOnEmailSplashScreen.current = false;
    };
  }, []);

  return (
    <Layout hideToolbar>
      <div className={styles['email-splash']}>
        <img src={paymentImage} alt="Email Sent Confirmation" />
        <Heading as="h6" color="textPrimary">
          {t('emailSplash.title')}
        </Heading>

        <Text as="span" color="textPrimary">
          {t('emailSplash.body')}
        </Text>

        <div className={styles['buttons']}>
          <Button onClick={viewDigitalGreetingOnClick} variant="secondary">
            <Icon name={IconNames.PlaysmallBold} />
            {t('emailSplash.animationButton')}
          </Button>
          <Button onClick={keepShoppingOnClick}>{t('emailSplash.continueButton')}</Button>
        </div>
      </div>
    </Layout>
  );
};
